import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getKvizLovacRangLista } from '../../../server/server-kviz';
import { useUser } from '../../../auth/UseUser';
import Loading from '../../../utils/Loading';

export const formatVreme = (ms: number) => {
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

function KvizLovacRangLista() {
    const navigate = useNavigate();
    const { user } = useUser();
    const [rezultati, setRezultati] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadRangLista();
    }, []);

    const loadRangLista = async () => {
        setLoading(true);
        const resp = await getKvizLovacRangLista(50);
        if (resp.status === 200) {
            setRezultati(resp.data ?? []);
        }
        setLoading(false);
    };

    return (
        <div className="flex h-full flex-col items-center bg-blueDark overflow-y-auto no-scroll pt-[20px] pb-[60px]">
            <div className="w-full max-w-[700px] px-[10px]">
                <div className="w-full bg-white rounded-[10px] p-6">
                    <div className="flex flex-row items-center justify-between mb-4">
                        <p className="text-blueDark text-[24px] font-bold">Rang lista - Kviz Lovac</p>
                        <button
                            onClick={() => navigate(-1)}
                            className="px-4 h-[38px] rounded-lg border-[2px] border-blueDark text-blueDark font-semibold"
                        >
                            Nazad
                        </button>
                    </div>
                    <p className="text-grey-600 text-[14px] mb-4">Najbrža vremena igrača koji su stigli do vrha piramide u takmičarskom modu (težina Teško).</p>

                    {loading && (
                        <div className="flex w-full justify-center py-10">
                            <Loading size={50} primaryColor="#234b98" stroke={3} />
                        </div>
                    )}

                    {!loading && rezultati.length === 0 && <p className="text-center text-grey-600 py-10">Još uvek nema rezultata.</p>}

                    {!loading && rezultati.length > 0 && (
                        <table className="w-full">
                            <thead>
                                <tr className="border-b border-blueMedium">
                                    <th className="text-left py-2 text-blueDark">Mesto</th>
                                    <th className="text-left py-2 text-blueDark">Korisnik</th>
                                    <th className="text-right py-2 text-blueDark">Vreme</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rezultati.map((r: any, index: number) => {
                                    const isMe = !!user?.id && user.id === r.userId;
                                    return (
                                        <tr key={r.userId} className={`border-b border-blueMedium/30 ${isMe ? 'bg-blueMedium/20 font-bold' : ''}`}>
                                            <td className="py-2 text-blueDark">{index + 1}.</td>
                                            <td className="py-2 text-blueDark">{r.username || 'Anonimni igrač'}</td>
                                            <td className="py-2 text-right text-blueDark">{formatVreme(r.vremeMs)}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
}

export default KvizLovacRangLista;
